import { useEffect } from 'react';
import { Logger } from '../../generic/utils';
import { wrapperIdentifier } from '../../wrappers/ApplicationWrapper/common';
import { wrapperBuilder } from './build';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}
const logic = wrapperBuilder.getCustomLogicRegisterInstance();

logic.setLogic(
  ({
    functions: { loadUserIdentityDocuments, loadLastScanId },
    bindedContexts: { user },
    variablesHandler: {
      variablesSetter,
      variables: { identityDocuments, lastMainScanId },
    },
  }) => {
    const userId = user && (user._id || user.id);

    useEffect(() => {
      if (userId) {
        // console.log('## Loading identityDocuments');
        loadUserIdentityDocuments(userId);
        // console.log('## Loading lastMainScanId');
        loadLastScanId(userId);
      } else if (!userId) {
        if (identityDocuments || lastMainScanId) {
          variablesSetter('identityDocuments')(undefined);
          variablesSetter('lastMainScanId')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
  }
);
